/**
 * First-of-month dates covering `min` through `max` (both `YYYY-MM-DD`),
 * inclusive of the months those days fall in.
 */
export function buildMonths(min: string, max: string): Date[] {
  const [minY, minM] = min.split('-').map(Number)
  const [maxY, maxM] = max.split('-').map(Number)
  const months: Date[] = []
  for (let y = minY, m = minM - 1; y < maxY || (y === maxY && m <= maxM - 1); ) {
    months.push(new Date(y, m, 1))
    m += 1
    if (m > 11) {
      m = 0
      y += 1
    }
  }
  return months
}
